import React from 'react';
import { Position, Mandate } from './styles';

export default ({ position, name, lastName, votes }) => {
	return <tr>
		<Position>{position}.</Position>
		<Mandate>{`${name} ${lastName}`}</Mandate>
		<td>{votes} hlasů</td>
	</tr>
}
